window.languageNotice = {
    $html: null,
    $htmlReplaceDiv: null,
    $wrapper: null,
    $closeBtn: null,
    $settingBtn: null,
    $hideBtn: null,
    $cookieDuration: 0,
    $cookieName: 'hideLanguageNotice',
    $cookieValue: '1',

    /**
     * Init Language Notice Script
     * @return void
     */
    init: function(currentCountry, currentLanguage, cookieDuration) {
        this.$wrapper = document.querySelector('.notice__wrapper');
        this.$htmlReplaceDiv = this.$wrapper.querySelector('.notice__replace');
        this.$cookieDuration = cookieDuration;

        this.checkForLanguageDiffer(currentCountry, currentLanguage);
    },

    /**
     * Initialise all Variables and Function after the Language Notice is loaded
     * @return void
     */
    initAfterReplace: function () {
        this.$closeBtn = this.$wrapper.querySelector('.notice__close');
        this.$settingBtn = this.$wrapper.querySelector('.notice__action--settings');
        this.$hideBtn = this.$wrapper.querySelector('.notice__action--hide');

        this.closeNotice();
        this.initSettingCheck();
        this.initHideNotice(this.$cookieDuration, this.$cookieName, this.$cookieValue);
    },

    /**
     * Initialize Close Action for Notice Box
     * @return void
     */
    closeNotice: function () {
        this.$closeBtn.addEventListener('click', function () {
            window.languageNotice.hide();
        });
    },

    /**
     * Hide Main Wrapper
     * @return void
     */
    hide: function () {
        this.$wrapper.style.display = 'none';
    },

    /**
     * Replace/Show the Language Notice
     * @return void
     */
    replace: function () {
        this.$htmlReplaceDiv.outerHTML = this.$html;
    },

    /**
     * Initialize Setting Check Action for Notice Box
     * @return void
     */
    initSettingCheck: function () {
        this.$settingBtn.addEventListener('click', function () {
            window.language.$langBtn.click();
        });
    },

    /**
     * Initialize Hide for the Language Notice Box in x days
     * defined in Variable $cookieDuration and save everything
     * in Cookie Named "hideLanguageNotice"
     *
     * @param {int} days
     * @param {string} name
     * @param {string} value
     * @return void
     */
    initHideNotice: function (days, name, value) {
        this.$hideBtn.addEventListener('click', function () {
            const date = new Date();
            const time = (days * 24 * 60 * 60 * 1000);
            let expires;

            date.setTime(date.getTime() + time);
            expires = "expires=" + date.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/;SameSite=Strict;";

            window.languageNotice.hide();
        });
    },

    /**
     * Get current Country/Language Code and prove with recommended Country/Language
     *
     * @param {string} currentCountryCode
     * @param {string} currentLanguageCode
     * @return void
     */
    checkForLanguageDiffer: function (currentCountryCode, currentLanguageCode) {
        const xhr = new XMLHttpRequest();

        xhr.onreadystatechange = function() {
            if (this.status === 200 && this.readyState === xhr.DONE) {
                const responseJson = JSON.parse(this.responseText);

                if (responseJson["countryCode"] !== currentCountryCode ||
                    responseJson["languageCode"] !== currentLanguageCode) {
                    if (!(new RegExp('(^| )' + window.languageNotice.$cookieName + '=','g').test(document.cookie))) {
                        window.languageNotice.replace();
                        window.languageNotice.initAfterReplace();
                    }
                }
            }
        };

        xhr.open("POST", "/userlanguage/suggest", true);
        xhr.send();
    }
}
